module.exports = __webpack_public_path__ + "img/perx_logo.171e9def.svg";